import {
    UPDATE_LLM_MODEL_CONFIG_PAGE_NUMBER,
    LLM_MODEL_CONFIGS_PENDING,
    GET_LLM_MODEL_CONFIGS,
    FETCH_LLM_MODEL_CONFIG,
    ADD_LLM_MODEL_CONFIG,
    EDIT_LLM_MODEL_CONFIG,
    DELETE_LLM_MODEL_CONFIG,
    CLEAR_LLM_MODEL_CONFIGS,
    UPDATE_LLM_USAGE_LOG_PAGE_NUMBER,
    LLM_USAGE_LOGS_PENDING,
    GET_LLM_USAGE_LOGS,
    FETCH_LLM_USAGE_LOG,
    ADD_LLM_USAGE_LOG,
    EDIT_LLM_USAGE_LOG,
    DELETE_LLM_USAGE_LOG,
    CLEAR_LLM_USAGE_LOGS,
  } from "../constants/actions";
  
  const initialState = {
    // LLM Model Configs
    llm_model_configs: [],
    llm_model_config: null,
    llm_model_configs_total: 0,
    llm_model_configs_page_number: 1,
    llm_model_configs_pending: false,
    llm_model_configs_error: null,
    llm_model_configs_message: null,
  
    // LLM Usage Logs
    llm_usage_logs: [],
    llm_usage_log: null,
    llm_usage_logs_total: 0,
    llm_usage_logs_page_number: 1,
    llm_usage_logs_pending: false,
    llm_usage_logs_error: null,
    llm_usage_logs_message: null,
  };
  
  export default function LLMLogReducer(state = initialState, action) {
    switch (action.type) {
      // ==================== LLM MODEL CONFIGS ====================
      case UPDATE_LLM_MODEL_CONFIG_PAGE_NUMBER:
        return {
          ...state,
          llm_model_configs_page_number: action.payload,
        };
  
      case LLM_MODEL_CONFIGS_PENDING:
        return {
          ...state,
          llm_model_configs_pending: true,
          llm_model_configs_error: null,
        };
  
      case GET_LLM_MODEL_CONFIGS:
        return {
          ...state,
          llm_model_configs: action.payload?.results || [],
          llm_model_configs_total: action.payload?.count || 0,
          llm_model_configs_pending: false,
          llm_model_configs_error: action.payload?.error || null,
        };
  
      case FETCH_LLM_MODEL_CONFIG:
        return {
          ...state,
          llm_model_config: action.payload || null,
          llm_model_configs_pending: false,
          llm_model_configs_error: action.payload?.error || null,
        };
  
      case ADD_LLM_MODEL_CONFIG:
        return {
          ...state,
          llm_model_configs_pending: false,
          llm_model_configs_error: action.payload?.error || null,
          llm_model_configs_message: action.payload?.error
            ? null
            : "LLM Model Config added successfully",
        };
  
      case EDIT_LLM_MODEL_CONFIG:
        return {
          ...state,
          llm_model_configs_pending: false,
          llm_model_configs_error: action.payload?.error || null,
          llm_model_configs_message: action.payload?.error
            ? null
            : "LLM Model Config updated successfully",
        };
  
      case DELETE_LLM_MODEL_CONFIG:
        return {
          ...state,
          llm_model_configs: state.llm_model_configs.filter(
            (config) => config.id !== action.payload.id
          ),
          llm_model_configs_pending: false,
          llm_model_configs_error: action.payload?.error || null,
          llm_model_configs_message: action.payload?.error
            ? null
            : "LLM Model Config deleted successfully",
        };
  
      case CLEAR_LLM_MODEL_CONFIGS:
        return {
          ...state,
          llm_model_configs: [],
          llm_model_config: null,
          llm_model_configs_total: 0,
          llm_model_configs_page_number: 1,
          llm_model_configs_pending: false,
          llm_model_configs_error: null,
          llm_model_configs_message: null,
        };
  
      // ==================== LLM USAGE LOGS ====================
      case UPDATE_LLM_USAGE_LOG_PAGE_NUMBER:
        return {
          ...state,
          llm_usage_logs_page_number: action.payload,
        };
  
      case LLM_USAGE_LOGS_PENDING:
        return {
          ...state,
          llm_usage_logs_pending: true,
          llm_usage_logs_error: null,
        };
  
      case GET_LLM_USAGE_LOGS:
        return {
          ...state,
          llm_usage_logs: action.payload?.results || [],
          llm_usage_logs_total: action.payload?.count || 0,
          llm_usage_logs_pending: false,
          llm_usage_logs_error: action.payload?.error || null,
        };
  
      case FETCH_LLM_USAGE_LOG:
        return {
          ...state,
          llm_usage_log: action.payload || null,
          llm_usage_logs_pending: false,
          llm_usage_logs_error: action.payload?.error || null,
        };
  
      case ADD_LLM_USAGE_LOG:
        return {
          ...state,
          llm_usage_logs_pending: false,
          llm_usage_logs_error: action.payload?.error || null,
          llm_usage_logs_message: action.payload?.error
            ? null
            : "LLM Usage Log added successfully",
        };
  
      case EDIT_LLM_USAGE_LOG:
        return {
          ...state,
          llm_usage_logs_pending: false,
          llm_usage_logs_error: action.payload?.error || null,
          llm_usage_logs_message: action.payload?.error
            ? null
            : "LLM Usage Log updated successfully",
        };
  
      case DELETE_LLM_USAGE_LOG:
        return {
          ...state,
          llm_usage_logs: state.llm_usage_logs.filter(
            (log) => log.id !== action.payload.id
          ),
          llm_usage_logs_pending: false,
          llm_usage_logs_error: action.payload?.error || null,
          llm_usage_logs_message: action.payload?.error
            ? null
            : "LLM Usage Log deleted successfully",
        };
  
      case CLEAR_LLM_USAGE_LOGS:
        return {
          ...state,
          llm_usage_logs: [],
          llm_usage_log: null,
          llm_usage_logs_total: 0,
          llm_usage_logs_page_number: 1,
          llm_usage_logs_pending: false,
          llm_usage_logs_error: null,
          llm_usage_logs_message: null,
        };
  
      default:
        return state;
    }
  }